import { render, staticRenderFns } from "./experienciaTextoComponent.vue?vue&type=template&id=1a8f8070&"
import script from "./experienciaTextoComponent.vue?vue&type=script&lang=js&"
export * from "./experienciaTextoComponent.vue?vue&type=script&lang=js&"
import style0 from "./experienciaTextoComponent.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports